import { render, staticRenderFns } from "./VocabularySelect.vue?vue&type=template&id=7079c988&scoped=true&"
import script from "./VocabularySelect.vue?vue&type=script&lang=js&"
export * from "./VocabularySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7079c988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7079c988')) {
      api.createRecord('7079c988', component.options)
    } else {
      api.reload('7079c988', component.options)
    }
    module.hot.accept("./VocabularySelect.vue?vue&type=template&id=7079c988&scoped=true&", function () {
      api.rerender('7079c988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mms/components/vocabulary/VocabularySelect.vue"
export default component.exports